import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/authcontext";
import ProtectedRoute from "./routes/protected";
import PublicRoute from "./routes/public";
import Home from "./Pages/Home/Home";
import Service from "./Pages/service";
import Works from "./Pages/works";
import Signin from "./Pages/auth/login";
import SignUp from "./Pages/auth/signup";
import AboutUs from "./Pages/AboutUs/about";
import Selectrole from "./Pages/auth/selection";
import Plotdetails from "./Pages/plot/plotdetails";
import PlotRequirements from "./Pages/plot/plotrequirements";
import Contractors from "./Pages/Contractors/Contractors";
import ContractorsProfile from "./Pages/ContractorsProfile/ContractorsProfile";
import BookingUI from "./Pages/Contractors/booking";
import CustomerRequirement from "./Pages/customerRequir/customerRequire";
import MileStone from "./Pages/payment/MileStone";
import Contractorsdetailsadd from "./Pages/Contractors/Contractorsdetailsadd";
import ContactUs from "./Pages/contact/contactus";
import ContractorsOwnProfile from "./Pages/ContractorsProfile/OwnProfile";
import UserMileStone from "./Pages/userBookings/userMilestones";
import MarkProject from "./Pages/Contractors/contractoMarkProject";
import EstimateSection from "./Pages/EstimateSection/EstimateSection";
import NotFound from "./Pages/NotFound";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";


const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/signin" element={<Signin />} />
            <Route path="/signUp" element={<SignUp />} />
            <Route path="/choose" element={<Selectrole />} />
          </Route>

          <Route path="/" element={<Home />} />
          <Route path="/works" element={<Works />} />
          <Route path="/Service" element={<Service />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/Mark-Project" element={<MarkProject />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/booking" element={<BookingUI />} />

            <Route
              path="/customer-requirements/:plotId"
              element={<CustomerRequirement />}
            />
            <Route path="/milestone/:id" element={<MileStone />} />
          </Route>

     


          <Route element={<ProtectedRoute requiredRole="ROLE_USER" />}>
            <Route path="/plot-details" element={<Plotdetails />} />
            <Route path="/plot-requirements" element={<PlotRequirements />} />
            <Route path="/mileStones/:id" element={<UserMileStone />} />
          </Route>

          <Route element={<ProtectedRoute requiredRole="ROLE_PROVIDER" />}>
            <Route path="/details-add" element={<Contractorsdetailsadd />} />
            <Route
              path="/contractors-profile"
              element={<ContractorsOwnProfile />}
            />

          </Route>

          <Route element={<ProtectedRoute requiredRole="ROLE_RM" />}>
            <Route path="/contractors" element={<Contractors />} />
            {/* <Route path="/milestone" element={<PayMentMileStone />} /> */}

            <Route
              path="/contractors-profile/:id"
              element={<ContractorsProfile />}
            />
                 <Route
            path="/estimate"
            element={< EstimateSection />}
          />

          </Route>
          {/* 404 Not Found Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
